import { Plus } from 'lucide-react'
import React from 'react'
import { cn } from '@/lib/utils';

interface ButtonFloatProps {
    onClick?: () => void;
}

const ButtonFloat = ({ onClick }: ButtonFloatProps) => {
    return (
        <button className={cn('fixed z-10 bottom-[150px] shadow  shadow-bg-grey-500 right-[30px] w-[56px] h-[56px] rounded-full bg-text-blue-100 text-white justify-center items-center text-center flex')} type='button' onClick={onClick}>
            <Plus />
        </button>
    )
}

export default ButtonFloat
